<template>
  <div :class="{'single-line':singleLine}" class="decimal-field">
    {{ formattedValue }}
  </div>
</template>

<script>
export default {
  name: 'tablefield-decimal',
  props: ['data', 'config', 'singleLine'],
  computed: {
    formattedValue() {
      return this.data.toLocaleString('de-DE', {
        minimumFractionDigits: this.config.decoratorOptions.format[2],
        maximumFractionDigits: this.config.decoratorOptions.format[4]
      })

    }
  }
}
</script>



// WEBPACK FOOTER //
// FieldDecimal.vue?6ab8805f